import { TaskCollectionView, TaskState } from '@ekkogmbh/apisdk';
import { Box, LinearProgress, LinearProgressProps, Stack, Tooltip, Typography } from '@mui/material';
import React, { useMemo } from 'react';

interface Props {
  taskCollection?: Pick<TaskCollectionView, 'id' | 'progress' | 'state'>;
}

export const TaskCollectionProgressBar = ({ taskCollection }: Props): React.JSX.Element => {
  const color = useMemo((): LinearProgressProps['color'] => {
    switch (taskCollection?.state) {
      case TaskState.CREATED:
        return 'warning';
      case TaskState.FAILED:
        return 'error';
      case TaskState.FINISHED:
        return 'success';
      case TaskState.RUNNING:
      default:
        return 'primary';
    }
  }, [taskCollection?.state]);

  if (taskCollection !== undefined) {
    const progress = taskCollection.progress ?? 0;
    return (
      <Tooltip arrow title={taskCollection.state} placement={'top'}>
        <Stack direction={'row'} spacing={1} justifyContent={'center'} alignItems={'baseline'}>
          <Typography>{taskCollection.id}</Typography>
          <LinearProgress
            style={{
              height: 10,
              width: '100%',
            }}
            color={color}
            variant={progress > 0 ? 'determinate' : 'indeterminate'}
            value={progress}
            sx={{}}
          />
        </Stack>
      </Tooltip>
    );
  }

  return <Box height={10} width={'100%'} />;
};
